import {
    auctionsNearMePageSizeOptions,
    defaultHitsPerPage,
} from '@/pages/AuctionsNearMe/constants/AuctionsNearMeConstants';
import { AuctionsNearMeQueryParams } from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';

/**
 * Reads `?pageSize=` so SSR renders the same number of results the client asked for. Anything the
 * picker cannot produce falls back to the default rather than reaching the backend — the value
 * goes straight into a near-me-v2 request, and the URL is reachable by anyone.
 */
export const getPageSizeFromQueryParams = (queryParams: AuctionsNearMeQueryParams) => {
    // A repeated ?pageSize= parses to an array (query-string), so read the first value rather
    // than stringifying the whole thing into "24,48".
    const rawPageSize = Array.isArray(queryParams.pageSize) ? queryParams.pageSize[0] : queryParams.pageSize;
    const pageSize = parseInt(String(rawPageSize), 10);

    return auctionsNearMePageSizeOptions.includes(pageSize) ? pageSize : defaultHitsPerPage;
};
